'use client';

import { LicenseInfo } from '@mui/x-license-pro';

// LicenseInfo.setLicenseKey('1c8b7599df2e9a71994f334043647ba6Tz04MjE5NSxFPTE3MzY3OTI2NzUwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');
// LicenseInfo.setLicenseKey('eb14a5094fd837b6ab028ef70c00add5Tz0xMDc5MDYsRT0xNzcxMTEzNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');
LicenseInfo.setLicenseKey('7f956c438df693ab16e437d9e3d58d67Tz0xMjY2MDUsRT0xODA0Mzc3NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=')

export default function MuiXLicense() {
  return null;
}